const initialState = {
    managersLoading: false,
    managersError: '',
    managersSuccess: '',
    managers: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case "MANAGERS_LOADING":
            return {
                ...state,
                managersLoading: true
            };
        case "MANAGERS_ERROR":
            return {
                ...state,
                managersLoading: false,
                managersError: action.error,
                managersSuccess: ''
            };
        case "MANAGERS_SUCCESS":
            return {
                ...state,
                managersLoading: false,
                managersError: '',
                managers: action.data.managers 
                    ? action.data.managers             
                    : [{
                        ...state.managers
                    }],
                managersSuccess: action.data.message || state.managersSuccess
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/managers.js